import PropTypes from 'prop-types';
import React from 'react';
import Validator from 'mixins/validator';
import Resetter from 'mixins/resetter';
import { Button } from 'react-toolbox/lib/button';
import { connect } from 'react-redux';
import ComposeWindow from 'components/ComposeWindow';
import TextArea from 'components/TextArea';

import S from 'components/ComposeWindow/styles.scss';
import { addEventToPhase, clearValidation } from 'actionCreators/phase';
import PhaseType from 'types/phase';
import { getPhaseErrors } from '../../../../../../reducers';

class AddNoteModal extends Resetter(Validator(React.Component)) {
  static DEFAULT_STATE = {
    note: '',
    errors: {},
  }
  static VALIDATIONS = { note: true }

  handleSubmit = () => {
    const note = this.textAreaComponentRef.textAreaRef.value;
    this.setState({ note }, () => {
      if (!this.validate()) return;
      const phaseID = this.props.phase.id;

      const noteProps = {
        name: 'Note',
        kind: 'note',
        data: { note },
      };

      this.props.addEventToPhase(phaseID, noteProps).then(() => {
        this.handleClose();
      })
      .catch(() => {}); // catching this to avoid console warnings...
    });
  }

  handleClose() {
    super.handleClose();
    this.props.clearValidation();
  }

  render() {
    const { errors } = this.state;
    const active = this.props.active;

    return (
      <ComposeWindow
        active={active}
        title="Add Note"
        onClose={this.handleClose}
      >
        <TextArea
          label="Notes *"
          defaultValue=""
          className={S.compose}
          errors={errors.note}
          autoFocus
          ref={(comp) => { this.textAreaComponentRef = comp; }}
        />
        <div className={S.actions}>
          <Button
            label="Add Note"
            primary flat ripple
            className={S.submit}
            onClick={this.handleSubmit}
          />
        </div>
      </ComposeWindow>
    );
  }
}

AddNoteModal.propTypes = {
  active: PropTypes.bool.isRequired,
  addEventToPhase: PropTypes.func.isRequired,
  clearValidation: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  phase: PhaseType.isRequired,
  errors: PropTypes.shape({
    note: PropTypes.arrayOf(PropTypes.string),
  }),
};

AddNoteModal.defaultProps = {
  active: false,
};

export default connect(
  state => ({ errors: getPhaseErrors(state) }),
  { addEventToPhase, clearValidation },
)(AddNoteModal);



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/components/addNoteModal.jsx